// extracted by mini-css-extract-plugin
export default {"container":"routes_container__SBMZU","app":"routes_app__LWaRx"};